import { localizedPrefix, rootPrefix } from '#/routing/routes';

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const viewJobReferencePath = rootPrefix.path(
  '-lang/-segment/:jobIdDashSlug',
  ['noSuggestions', 'listingApplicationTmpId'],
);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const viewInternshipReferencePath = rootPrefix.path(
  '-lang/-segment/:internshipIdDashSlug',
  ['listingApplicationTmpId'],
);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const viewVolopReferencePath = rootPrefix.path(
  '-lang/-segment/:volopIdDashSlug',
  ['listingApplicationTmpId'],
);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const viewEventReferencePath = rootPrefix.path(
  '-lang/-segment/:eventIdDashSlug',
);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const viewOrgReferencePath = rootPrefix.path(
  '-lang/-segment/:orgIdDashSlug',
  ['tab'],
);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const viewGroupReferencePath = rootPrefix.path(
  '-lang/-segment/:orgIdDashSlug',
  ['tab'],
);

export const importedEventPath = localizedPrefix.path(
  'imported-action-opps/:source/:eventId',
);
